import React from 'react';

function Breadcrumbs({ href, text, additional }) {
	return (
		<div className="breadcrumbs mb-4" style={{color:'#9e9e9e'}}>
			<a className="link text-decoration-none" href="/">Blog</a>
			<span className="divider">/</span>
			<a className="link text-decoration-none text-muted" href={href}>{text}</a>
			{additional &&
				<>
					<span className="divider">/</span>
					<span>{additional}</span>
				</>
			}
		</div>
	);
}

export default Breadcrumbs;
